$(document).ready(function() {

  // var myConfObj = {
  //   iframeMouseOver : false
  // }
  // window.addEventListener('blur',function(){
  //   if(myConfObj.iframeMouseOver){
  //     console.log('Wow! Iframe Click!');
  //   }
  // });

  // document.getElementById('ctabutton1').addEventListener('mouseover',function(){
  //    myConfObj.iframeMouseOver = true;
  // });
  // document.getElementById('ctabutton1').addEventListener('mouseout',function(){
  //     myConfObj.iframeMouseOver = false;
  // });

  // As Seen On carousel
  var $as_seen_carousel = $('.flickity-reviews').flickity();

  $as_seen_carousel.on('staticClick.flickity', function (event, pointer, cellElement, cellIndex) {
    //console.log(event);

    $as_seen_carousel.flickity('select', cellIndex);
  });

  // Celeb Video Modal on index page
  var $celeb_carousel = $('.celeb-carousel').flickity();

  $celeb_carousel.on('staticClick.flickity', function (event, pointer, cellElement, cellIndex) {
    //console.log(event);

    $celeb_carousel.flickity('select', cellIndex);

    var target;
    if ($(event.target).hasClass('carousel-cell')) {
      target = $(event.target);
    } else {
      target = $($(event.target).parents('.carousel-cell').get(0));
    }

    $('#celeb-video-modal .modal-title').text(target.attr('data-celeb-name'));
    $('#celeb-video-modal h3').text(target.attr('data-subtext'));
    $('#celeb-video-modal video').attr("src", target.attr('data-video-url'));

    $('#celeb-video-modal').modal('show');
  });

  $("#celeb-video-modal").on('hide.bs.modal', function(event) {
    $("#celeb-video-modal video").get(0).pause();
  });



  // Review page click to slide
  var $reviews_carousel = $('#reviews-page-carousel').flickity();

  $reviews_carousel.on('staticClick.flickity', function (event, pointer, cellElement, cellIndex) {
    //console.log(event);

    $reviews_carousel.flickity('select', cellIndex);
  });



  // Product Video Slider Play
  $('#product-carousel').on('change.flickity', function(event, index) {
    $("#product-carousel .carousel-cell:not(.is-selected)").each(function(index, elem) {
      if ($(elem).find('video').get(0) != undefined) {
        $(elem).find('video').get(0).pause();
      }
    });
    if ($("#product-carousel .carousel-cell.is-selected video").get(0) != undefined) {
      $("#product-carousel .carousel-cell.is-selected video").get(0).play();
    }
  });



  // Play Icons GIFs
  //  - video element must have attribute ud-video-hover
  //  - video element must have attribute muted
  if ($(window).width() < 576) {
    $('[ud-video-hover]').each(function() {
      this.loop = true;
      this.play();
    });
  } else {
    $('[ud-video-hover]').hover(function() {
      this.play();
    });
  }




  // Add to Cart Sticky
  if ($("#addtocart").length > 0 && $('#shopify-section-ud-product').length == 0) {

    var btn = $('#addtocart');

    btn.css('transition', 'none');

    var btnText = btn.text().trim();

    var btnW = $('#addtocart').outerWidth();
    var btnH = $('#addtocart').outerHeight();
    var btnX = $('#addtocart').offset().left;
    var btnY = $('#Header').offset().top + $('#Header').outerHeight() - $(window).scrollTop() + 15;

    var isSticky = false;

    $(window).on('scroll',function(){
      var divBottom = $('#AddToCartForm').offset().top + $('#AddToCartForm').height();
      var navBottom = $('#Header').offset().top + $('#Header').outerHeight();
      var btnTop = divBottom - btn.outerHeight() - 15;

      if (navBottom >= btnTop + 50 && isSticky) {

        btn.css('left', '');
        btn.css('min-width', 'auto');

        btn.animate({
          right: '15px',
          width: '165px'
        }, 400, function() {});

      } else if (navBottom >= btnTop && !isSticky) {

        btnW = btn.outerWidth();
        btnH = btn.outerHeight();
        btnX = btn.offset().left;
        btnY = $('#Header').offset().top + $('#Header').outerHeight() - $(window).scrollTop() + 15;
        btn.css('width', btnW);
        btn.css('height', btnH);
        btn.css('top', btnY);
        btn.css('left', btnX);
        btn.addClass('sticky-el');
        if ($('#digital-gift-card').length > 0) {
          btn.text('Select Amount');
        } else {
          btn.text('Select Size');
        }

        isSticky = true;

      } else if (navBottom < btnTop && isSticky) {

        btn.finish();

        btn.removeClass('sticky-el');
        btn.css('height', '');
        btn.css('top', '');
        btn.css('left', '');
        btn.css('width', '');
        btn.css('right', '');
        btn.css('min-width', '');
        btn.text(btnText);

        isSticky = false;

      }
    });

    btn.click(function(event) {
      if ($(this).hasClass('sticky-el')) {
        event.preventDefault();

        window.scrollTo({
          top: $($('.product__info--wrap').get(0)).offset().top - $('#Header').offset().top - $('#Header').outerHeight() + $(window).scrollTop() - 15,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  }

  // Add to Cart Sticky - New
  if ($("#addtocart").length > 0 && $('#shopify-section-ud-product').length != 0) {

    var addBtn = $('#addtocart');
    var stickyBtn = $('#sticky-btn');

    $(window).on('scroll', function() {
      var navBottom = $('#Header').offset().top + $('#Header').outerHeight();
      var addBottom = $('#addtocart').offset().top + $('#addtocart').outerHeight()

      if (navBottom > addBottom) {
        stickyBtn.css('top', $('#shopify-section-header').outerHeight())
      } else {
        stickyBtn.css('top', '-100%')
      }
    })

    stickyBtn.click(function(event) {
      event.preventDefault();

      window.scrollTo({
        top: $('.product-title').offset().top - $('#Header').outerHeight(),
        left: 0,
        behavior: 'smooth'
      });
    });
  }
});
